export default __webpack_public_path__ + "static/media/destroyed_16@2x.9a0f61b0.png";